import { useRouteMatch, useParams } from 'react-router-dom'
import { SubmissionsHeader } from '@components/headers/submissions'
import { useAppSelector } from '@redux/hooks'
import { SubmissionsHeaderDetailsContainer } from './submissionsHeaderDetailsContainer'
import { SubmissionsHeaderSelectiveContainer } from './submissionsHeaderSelectiveContainer'
import { t } from '@lingui/core/macro'
import { Location } from 'history'

interface SubmissionsHeaderContainerProps {
  location: Location
}

interface SubmissionsHeaderContainerRouterParams {
  id?: string
}

export const SubmissionsHeaderContainer = ({ location }: SubmissionsHeaderContainerProps) => {
  const params = useParams<SubmissionsHeaderContainerRouterParams>()
  const isSubmissionPage =
    useRouteMatch<SubmissionsHeaderContainerRouterParams>('/codes/details/:id')
  const id = isSubmissionPage?.params.id ?? null
  const meta = useAppSelector(state => state.Datasets.datasetMetadataById[id])
  const isDetailsPath = Boolean(location.pathname.includes('details'))
  const title = getTitle()

  const page = location.pathname.split('/').reverse()[0]
  const isSelectiveRoute = page === 'selective'

  // Order matters.
  if (isSelectiveRoute) {
    return <SubmissionsHeaderSelectiveContainer />
  }

  if (isDetailsPath) {
    return <SubmissionsHeaderDetailsContainer datasetId={id ?? ''} templateId={meta?.template_id} />
  }

  return <SubmissionsHeader templateId={params.id ?? ''} title={title} />

  /**
   * Get the page header title.
   * - Details path and submission name; show submission name.
   * - Submissions page (ready-only); return the submission name or an untitled submission name.
   * - Template when not a submission.
   * - Lastly, the tab title.
   * @returns {string} The title of the page header.
   */
  function getTitle() {
    if (isSubmissionPage) return meta?.identifier ? meta?.identifier : t`Untitled Submission`

    if (meta) {
      return meta?.template_name || ''
    }

    const pageName = location.pathname.split('/').reverse()[0]!
    const capitlizePageName = pageName.charAt(0).toUpperCase() + pageName.slice(1)

    return capitlizePageName
  }
}
